import { TextBadge } from '#/components/Badge/TextBadge';
import { useI18n } from '#/i18n/hooks/useI18n';
import { SEARCH_COMMON_REFINEMENT_LABELS } from '#/modules/search/constants/refinements/searchCommonRefinementTypes';
import { useSearchSingleChoiceSelectedValue } from '#/modules/search/hooks/facets/useSearchSingleChoiceSelectedValue';
import type { SearchRefinementVariant } from '#/modules/search/types/SearchRefinementVariant';
import { RECENCY_PERIOD_RADIO_OR_SELECT_OPTIONS } from '#/utils/constants/general/recency';

import { SearchFacetAccordionItem } from './AccordionItem/SearchFacetAccordionItem';
import { SearchFacetDropdown } from './Dropdown/SearchFacetDropdown';
import { SearchFacetRadioButtonOptions } from './Options/SearchFacetRadioButtonOptions';

type Props = {
  variant: SearchRefinementVariant;
};
export function RecencyFacet({ variant }: Props) {
  const { i18n } = useI18n();

  const selectedFacetValue = useSearchSingleChoiceSelectedValue('recency');
  const selectedCount = selectedFacetValue ? 1 : 0;

  const FacetVariant =
    variant === 'accordion' ? SearchFacetAccordionItem : SearchFacetDropdown;

  return (
    <FacetVariant
      facetType="recency"
      icon="clock"
      label={
        <>
          {SEARCH_COMMON_REFINEMENT_LABELS(i18n).recency}{' '}
          <TextBadge content={selectedCount} />
        </>
      }
    >
      <SearchFacetRadioButtonOptions
        facetType="recency"
        initialValue={selectedFacetValue}
        options={RECENCY_PERIOD_RADIO_OR_SELECT_OPTIONS(i18n)}
        variant={variant === 'accordion' ? 'accordion' : 'dropdown'}
      />
    </FacetVariant>
  );
}
